import React, {memo, useMemo} from 'react';
import {Avatar} from 'antd';
import PropTypes from 'prop-types';
import Email from '@/components/Email';
import UserStatus from '@/modules/admin/components/UserStatus';
import {Link} from 'react-router-dom';
import cn from 'classnames';

const UserCell = ({user, path, disableLink, showEmail, showStatus}) => {

  const content = useMemo(() => (
    <div className={'flex flex-row'}>
      <div className={'flex lg:items-center mr-2 lg:mr-2 min-w-8'}>
        <Avatar src={user?.avatar}/>
      </div>
      <div className={'flex flex-col justify-center leading-3 truncate'}>
        <span className={cn(
          'font-medium lg:font-normal text-lg lg:text-base text-black',
          {'lg:text-primary': !disableLink}
        )}>
          {user?.fullName}
        </span>
        <span className={cn('mt-1', {'lg:hidden': !showEmail})}>
          <Email item={user}>{user?.email}</Email>
        </span>
        {user?.phone && <span className={'mt-1 lg:hidden'}>{user?.phone}</span>}
        {showStatus && user?.status && <span className={'md:hidden mt-1'}><UserStatus status={user?.status}/></span>}
      </div>
    </div>
  ), [disableLink, showEmail, showStatus, user]);

  if (disableLink) {
    return content;
  }

  return (
    <Link to={`${path}/${user?._id}`}>
      {content}
    </Link>
  );
};

UserCell.propTypes = {
  user: PropTypes.object,
  path: PropTypes.string,
  disableLink: PropTypes.bool,
  showEmail: PropTypes.bool,
  showStatus: PropTypes.bool,
};

UserCell.defaultProps = {
  path: '/admin/users'
};

export default memo(UserCell);


/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} user this is the row instance
 * */
export const renderUser = (text, user) => {
  return (
    <UserCell user={user}/>
  );
};

export const createRenderUser = (config = {}) => {
  const {...defaultProps} = config;

  // eslint-disable-next-line react/display-name
  return (user) => {
    return (
      <UserCell user={user} {...defaultProps}/>
    );
  };
};

